export const THIRTY_SECONDS = 30000
export const MAX_RETRIES = 20
